import { ReactNode } from 'react'
import BackButton from '../BackButton'

interface Props {
    children: ReactNode
    displayBackButton?: boolean
    returnUrl?: string
    // eslint-disable-next-line @typescript-eslint/ban-types
    beforeNavigateBack?: () => Promise<boolean>
    className?: string
    tabletWidth?: string
    desktopWidth?: string
    maxWidth?: string
    marginX?: string
}

const Container = ({
    children,
    displayBackButton,
    returnUrl,
    beforeNavigateBack,
    className,
    tabletWidth,
    desktopWidth,
    maxWidth,
    marginX,
}: Props) => {
    const displayButton = displayBackButton !== false

    return (
        <>
            {displayButton && (
                <div>
                    <BackButton returnUrl={returnUrl} beforeNavigate={beforeNavigateBack}>
                        Back
                    </BackButton>
                </div>
            )}
            <div
                className={`tablet:w-${tabletWidth ?? '5/6'} desktop:w-${desktopWidth ?? '2/3'} max-w-${
                    maxWidth ?? 'xl'
                } mx-${marginX ?? 'auto'} ${className ?? ''} px-4 pb-6`}
            >
                {children}
            </div>
        </>
    )
}

export default Container
